/* =============================================================================
 * Envelope Solicitacao.
 *
 * Obrigatorio em TODA chamada: o servidor lanca excecao se vier null, e
 * desreferencia Solicitacao.Usuario. Para acesso anonimo vai um usuario
 * sintetico com IdUsuario 0 - e' assim que o backend reconhece o visitante.
 * ========================================================================== */

import { config } from '@shared/lib/config.js';
import { sessao } from '@shared/sessao/sessao.js';
import { paraInteiro } from '@shared/lib/valores.js';

const USUARIO_ANONIMO = {
    IdUsuario: 0,
    Nome: 'Acesso Anônimo',
    Login: 'Anonimo',
    Email: '',
    IdIdioma: 0,
    UsuarioMaster: false,
};

function usuarioCompacto() {
    const u = sessao.usuario;
    if (!u) return USUARIO_ANONIMO;
    return {
        IdUsuario: paraInteiro(u.IdUsuario),
        Nome: u.Nome ?? '',
        Login: u.Login ?? '',
        Email: u.Email ?? '',
        IdIdioma: paraInteiro(u.IdIdioma),
        UsuarioMaster: u.UsuarioMaster === true,
    };
}

export function montarSolicitacao(nomeFuncionalidade) {
    return {
        Identificador: crypto.randomUUID(),
        GeracaoInicial: new Date(),
        Usuario: usuarioCompacto(),
        //Vazio no primeiro boot: o servidor resolve pelo dominio e devolve o
        //valor, que passa a ser enviado nas chamadas seguintes.
        IdentificadorConexao: config.identificadorConexao,
        NomeProcesso: nomeFuncionalidade,
        NomApp: 'Futigol',
        NroPaginaAtual: 1,
        PosicaoRegistroInicial: 1,
        UrlServico: config.urlServico,
        UrlOrigem: globalThis.location?.href ?? '',
        DispositivoCliente: globalThis.navigator?.userAgent ?? '',
        AcessoApp: false,
        GerarSqlRowNum: true,
    };
}
